import { Theme } from '@mui/material';


const Tooltip = (theme: Theme) => {
  return {
  };
};

export default Tooltip;
